import { useContext } from "react";
import { uniqueId } from "lodash";
import { EditableContext } from "../../common/EditableContextProvider";
import { FormPaso } from "./FormPaso";
import { Modal, Table } from "antd";
const { Column } = Table;

export const TablePasos = () => {
    const { casos, pasos } = useContext(EditableContext);
    return (
        <div className="mb-2">
            <h5>Pasos</h5>
            {
                (casos.editItem.id > 0) ? (
                    <div className="my-2">
                        <Table
                            size="small"
                            dataSource={casos.editItem.pasos}
                            rowKey='id'
                            pagination={{ position: [] }}
                            scroll={{ y: 400, }}
                            footer={() => (<>
                                <a href="#" className="" onClick={() => pasos.newPaso()}>
                                    Agregar...
                                </a>
                            </>)}
                            bordered
                        >
                            <Column title="*" dataIndex="id" key="buttons" width={90} className="text-center"
                                render={(id, row) => (<>
                                    <button className="btn btn-sm btn-light border"
                                        onClick={() => pasos.selectPaso(row)}
                                    >
                                        <span className="fas fa-pen"></span>
                                    </button>
                                    <button className="btn btn-sm btn-light border ms-1"
                                        onClick={() => pasos.handle_delete_paso(row)}
                                    >
                                        <span className="fas fa-trash"></span>
                                    </button>
                                </>)}
                            />
                            <Column title="ID" dataIndex="id" key="id" align="center" className="fw-bold"
                                width={60}
                                render={(value) => sprintf('%04d', value)}
                            />

                            <Column title="no" dataIndex="id" key="." align="center"
                                width={100}
                                render={(value, row) => (
                                    <div className="d-flex flex-row align-items-center justify-content-center">
                                        <div className="d-flex flex-column">
                                            <button className="btn px-1 py-0 border" style={{ lineHeight: '12px', fontSize: '12px' }}
                                                onClick={() => pasos.changeNo(row.id, 'up')}
                                            >
                                                <span className="fas fa-chevron-up"></span>
                                            </button>
                                            <button className="btn px-1 py-0 border" style={{ lineHeight: '12px', fontSize: '12px' }}
                                                onClick={() => pasos.changeNo(row.id, 'down')}
                                            >
                                                <span className="fas fa-chevron-down"></span>
                                            </button>
                                        </div>
                                        <span className="ps-2">
                                            {sprintf("%02d", row.no)}
                                        </span>
                                    </div>
                                )}
                            />

                            <Column title="Descripción/Notificación" dataIndex="descripcion" key="descripcion"
                                width={300}
                                render={(value, row) => (<>
                                    <b>{row.descripcion}</b> <br />
                                    (<i>Notificación: "{row.notificacion}"</i>)
                                </>)}
                            />

                            <Column title="Estado" dataIndex="estado" key="estado"
                                width={150}
                                render={(value, row) => (<>
                                    <select name="estado" id="estado"
                                        className="form-select form-select-sm"
                                        value={row.estado}
                                        onChange={(e) => pasos.changeEstado(row.id, e.target.value)}
                                        disabled={pasos.loadingEstado}
                                    >
                                        <option value="PENDIENTE">PENDIENTE</option>
                                        <option value="REALIZADO">REALIZADO</option>
                                    </select>
                                </>)}
                            />
                        </Table>

                        {/* <table className="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '80px' }}></th>
                                    <th className="text-end">No</th>
                                    <th>Descripción / Notificación</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    casos.editItem.pasos.map((paso, i) => {
                                        let uid = uniqueId();
                                        return (
                                            <tr key={uid}>
                                                <td className="text-center">
                                                    <button className="btn btn-sm btn-light border"
                                                        onClick={() => pasos.selectPaso(paso)}
                                                    >
                                                        <span className="fas fa-pen"></span>
                                                    </button>
                                                    <button className="btn btn-sm btn-light border ms-1"
                                                        onClick={() => pasos.handle_delete_paso(paso)}
                                                    >
                                                        <span className="fas fa-trash"></span>
                                                    </button>
                                                </td>
                                                <td className="text-end fw-bold">
                                                    <div className="d-flex flex-row align-items-center justify-content-center">
                                                        <div className="d-flex flex-column">
                                                            <button className="btn px-1 py-0 border" style={{ lineHeight: '12px', fontSize: '12px' }}
                                                                onClick={() => pasos.changeNo(paso.id, 'up')}
                                                            >
                                                                <span className="fas fa-chevron-up"></span>
                                                            </button>
                                                            <button className="btn px-1 py-0 border" style={{ lineHeight: '12px', fontSize: '12px' }}
                                                                onClick={() => pasos.changeNo(paso.id, 'down')}
                                                            >
                                                                <span className="fas fa-chevron-down"></span>
                                                            </button>
                                                        </div>
                                                        <span className="ps-2">
                                                            {sprintf("%02d", paso.no)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <b>{paso.descripcion}</b> <br />
                                                    (<i>Notificación: "{paso.notificacion}"</i>)
                                                </td>
                                                <td>
                                                    <select name="estado" id="estado"
                                                        className="form-select form-select-sm"
                                                        value={paso.estado}
                                                        onChange={(e) => pasos.changeEstado(paso.id, e.target.value)}
                                                        disabled={pasos.loadingEstado}
                                                    >
                                                        <option value="PENDIENTE">PENDIENTE</option>
                                                        <option value="REALIZADO">REALIZADO</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }

                                <tr>
                                    <td colSpan={20}>
                                        <a href="#" className="" onClick={() => pasos.newPaso()}>
                                            Agregar...
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                    </div>
                ) : (<>Guarda el registro para agregar pasos.</>)
            }

            <Modal
                open={pasos.visibleFormPaso}
                onCancel={pasos.closeFormPaso}
                destroyOnClose={true}
                footer={null}
            >
                <FormPaso />
            </Modal>
        </div>
    );
}